import useMartyContext from 'hooks/useMartyContext';
import MelodyGrid from 'components/landing/MelodyGrid';
import MelodyCurated from 'components/landing/MelodyCurated';
import MelodyCarousel from 'components/common/MelodyCarousel';
import MelodyCardProduct from 'components/common/melodyCard/MelodyCardProduct';
import ProductList from 'components/landing/ProductList';
import ProductGrid from 'components/common/ProductGrid';
import ProductCarousel from 'components/common/ProductCarousel';
import ProductResults from 'components/landing/ProductResults';
import { withErrorBoundary } from 'components/common/MartyErrorBoundary';
import { evSearchProductStreamClick, evSearchProductStreamImpression } from 'events/symphony';
import { track } from 'apis/amethyst';

import css from 'styles/components/landing/productSearch.scss';

export const ProductSearch = props => {
  const { marketplace: { landing: { hasProductSearchCarousel } } } = useMartyContext();
  const { slotName, slotDetails, onComponentClick, shouldLazyLoad, slotHeartsData } = props;
  if (slotDetails.products?.length > 0) {
    const { style, title, products, monetateId } = slotDetails;
    switch (true) {
      case style === 'melody-grid':
        return <MelodyGrid {...props} shouldLazyLoad={shouldLazyLoad}/>;
      case style === 'melody-grid-half':
        return <MelodyGrid {...props} isHalf={true} shouldLazyLoad={shouldLazyLoad}/>;
      case style === 'melody-curated':
        return <MelodyCurated {...props}/>;
      case style === 'product-list':
        return <ProductList {...props}/>;
      case style === 'product-grid':
        return <ProductGrid {...props}/>;
      case style === 'carousel' && hasProductSearchCarousel:
        return <ProductCarousel {...props}/>;
      case style === 'default-results':
        return <ProductResults {...props}/>;
      default: // style === 'melody' or no style property provided
        return (
          <div className={css.wrap} data-slot-id={slotName} data-monetate-id={monetateId}>
            <h2 className={css.title}>{title}</h2>
            <MelodyCarousel onDidMount={() => track(() => ([evSearchProductStreamImpression, props]))}>
              {products.map((product, index) => <MelodyCardProduct
                cardData={product}
                componentStyle="productSearchNoStyle"
                eventLabel="productSearch"
                onComponentClick={(evt, product) => {
                  onComponentClick && onComponentClick(evt, product);
                  track(() => ([evSearchProductStreamClick, { ...props, product }]));
                }}
                index={index}
                key={index}
                heartsData={slotHeartsData} />)}
            </MelodyCarousel>
          </div>
        );
    }
  } else {
    return null;
  }
};

export default withErrorBoundary('ProductSearch', ProductSearch);
